export default function IconCheck({ active }) {
    return (
        <div className="w-5">
            <svg
                fill="none"
                viewBox="0 0 21 22"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M10.5.985C4.701.985 0 5.686 0 11.485c0 5.8 4.701 10.5 10.5 10.5s10.5-4.7 10.5-10.5C20.993 5.69 16.296.992 10.5.985z"
                    fill={active ? '#4ACE8F' : '#CAE5FF'}
                />
                <path
                    d="M16.561 8.161l-5.99 8.128a.885.885 0 01-1.25.164l-4.277-3.42a.875.875 0 111.093-1.366l3.567 2.853 5.448-7.394a.875.875 0 111.41 1.035z"
                    fill={active ? 'white' : '#1890FF'}
                />
            </svg>
        </div>
    );
}
